import { useId } from 'react';
import { MONTH_NAMES, buildYearOptions } from '../../utils/vacationMonthFilter';
import type { MonthYearSelectProps } from './monthYearSelect.types';

export function MonthYearSelect({
    month,
    year,
    onMonthChange,
    onYearChange,
    allowAllMonths = true,
    allowAllYears = true,
    monthLabel = 'Mês',
    yearLabel = 'Ano',
    yearOptions,
}: MonthYearSelectProps) {
    const defaultYearOptions = buildYearOptions(new Date());
    const optionsToUse = yearOptions ?? defaultYearOptions;
    const monthDisabled = allowAllYears && year === null;
    const monthId = useId();
    const yearId = useId();

    return (
        <div className="flex gap-3">
            <div className="w-28">
                <label className="block text-sm font-medium text-raro-gray-700 font-montserrat">
                    {yearLabel}
                </label>
                <select
                    id={yearId}
                    value={year ?? ''}
                    onChange={(event) => onYearChange(event.target.value ? Number(event.target.value) : null)}
                    className="mt-1 w-full rounded-xl border border-raro-gray-200 py-2 px-3 text-sm text-raro-gray-900 focus:border-primary-500 focus:ring-primary-500 font-montserrat"
                >
                    {allowAllYears && <option value="">Todos</option>}
                    {optionsToUse.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>
            </div>

            <div className="flex-1 min-w-[9.5rem]">
                <label htmlFor={monthId} className="block text-sm font-medium text-raro-gray-700 font-montserrat">
                    {monthLabel}
                </label>
                <select
                    id={monthId}
                    value={month ?? ''}
                    onChange={(event) =>
                        onMonthChange(event.target.value ? Number(event.target.value) : null)
                    }
                    disabled={monthDisabled}
                    className="mt-1 w-full rounded-xl border border-raro-gray-200 py-2 px-3 text-sm text-raro-gray-900 focus:border-primary-500 focus:ring-primary-500 font-montserrat disabled:bg-raro-gray-50 disabled:text-raro-gray-400"
                >
                    {allowAllMonths && <option value="">Todos os meses</option>}
                    {MONTH_NAMES.map((name, index) => (
                        <option key={name} value={index + 1}>
                            {name}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}

export default MonthYearSelect;
